/**
 * True when `data` is a rectangular 2D table with at least two columns and
 * one header row plus at least one data row (Google Charts / react-google-charts).
 */
export function isValidGoogleChartsMatrixData(data: unknown): boolean {
  if (!Array.isArray(data)) {
    return false
  }
  if (data.length < 2) {
    return false
  }
  const header = data[0]
  if (!Array.isArray(header) || header.length < 2) {
    return false
  }
  const width = header.length
  for (let i = 1; i < data.length; i++) {
    const row = data[i]
    if (!Array.isArray(row) || row.length !== width) {
      return false
    }
  }
  return true
}
